import { Nav } from "@/components/prometheus/Nav";
import { Footer } from "@/components/prometheus/Footer";
import { GreatMindsExplorer } from "@/components/prometheus/GreatMindsExplorer";
import { useState, useEffect } from "react";
import { projects as staticProjects, inventors as staticInventors } from "@/data/projectsData";
import { useNavigate } from "react-router-dom";
import { prometheusApi, fetchApi } from "@/lib/apiClient";

const MindsPage = () => {
  const navigate = useNavigate();
  const [projectsList, setProjectsList] = useState(staticProjects);
  const [inventorsList, setInventorsList] = useState(staticInventors);

  useEffect(() => {
    document.title = "Grandes Mentes — Prometheus Lab AI";
    const fetchData = async () => {
      try {
        const [pData, iData] = await Promise.all([
          prometheusApi.getProjects().catch(() => null),
          fetchApi<any[]>("/api/inventors", { method: "GET" }).catch(() => null),
        ]);
        if (Array.isArray(pData) && pData.length > 0) setProjectsList(pData);
        if (Array.isArray(iData) && iData.length > 0) setInventorsList(iData);
      } catch {}
    };
    fetchData();
  }, []);

  return (
    <main className="min-h-screen bg-background text-foreground">
      <Nav />
      <div className="pt-16">
        <GreatMindsExplorer
          onSelectProject={(id) => navigate(`/taller?project=${id}`)}
          inventorsList={inventorsList}
          projectsList={projectsList}
        />
      </div>
      <Footer />
    </main>
  );
};

export default MindsPage;
